import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';

@Component({
  selector: 'lib-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  imports: [FormsModule, NgIf, NgFor, NgClass, ReactiveFormsModule],
})
export class DropdownComponent {
  @ViewChild('inputField') input_element?: ElementRef<HTMLInputElement>;
  @Input() validator?: RegExp;
  @Input() formArray: FormArray<any> = new FormArray<any>([]);

  isOpen = false;
  isIconDisplay = true;
  isFocus = false;
  current = 0;
  isSelected = false;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    if (this.formArray == null) {
      this.formArray = new FormArray<any>(['']);
    }
  }

  getPlaceholder(): string {
    if (this.isFocus) {
      return 'New entry';
    }
    if (this.formArray.value.length > 1) {
      return `${this.formArray.value.length - 1} Entries`;
    }
    return 'New entry';
  }

  onBlur(): void {
    this.isIconDisplay = true;
    if (this.formArray.value.length > 1) {
      this.isFocus = false;
    }
  }

  onFocus(): void {
    this.isIconDisplay = false;
    if (this.formArray.value.length > 1) {
      this.isFocus = true;
    }
  }

  onInput(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    if (!inputValue.trim() && this.isSelected) {
      this.formArray.removeAt(this.current);
      this.isSelected = false;
      this.current = 0;
    }
  }

  handleBackgroundClick(event: MouseEvent) {
    const containerWidth = (event.target as HTMLElement).offsetWidth;
    const clickX =
      event.clientX -
      (event.target as HTMLElement).getBoundingClientRect().left;

    const threshold = 40;
    if (containerWidth - clickX <= threshold) {
      this.isOpen = !this.isOpen;
    }
  }

  onAdd(): void {
    this.isSelected = false;

    if (
      this.current === 0 &&
      this.formArray.controls[this.current].value.trim() != ''
    ) {
      const item = this.fb.control(this.formArray.controls[this.current].value);
      this.formArray.push(item);
      this.formArray.controls[this.current].reset();
    } else {
      this.current = 0;
    }

    if (this.formArray.value.length > 1) {
      this.isFocus = true;
    }
  }

  editItem(i: number) {
    this.current = i;
    this.isSelected = true;
  }

  regexValidator(pattern: RegExp) {
    return (control: FormControl) => {
      const isValid = pattern.test(control.value);
      return isValid ? null : { pattern: { valid: false } };
    };
  }

  checkAndRemove(event: any): void {
    const inputValue = event.target.value;
    if (!inputValue.trim() && this.isSelected) {
      this.formArray.removeAt(this.current);
      this.isSelected = false;
      this.current = 0;

      if (
        this.formArray.value.length > 1 &&
        this.input_element?.nativeElement
      ) {
        this.input_element.nativeElement.placeholder = `${this.formArray.value.length - 1} Entries`;
      } else if (this.input_element?.nativeElement) {
        this.input_element.nativeElement.placeholder = 'New entry';
      }
    }
  }
  updateValue(newValue: any): void {
    this.formArray.controls[this.current].patchValue(newValue);
  }
}
